import axios from 'axios'

const URL_PATH = 'api/relatorios'

class PainelApiClient {
	async buscarListagem() {
		return await axios.get(`${URL_PATH}/customizados`)
	}
}

export default new PainelApiClient()
